import React from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
// @ts-ignore
import HubspotForm from 'react-hubspot-form';
class GreetingsPopup extends AbstractWelcomePage {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            hide: true
        };
        this._onToggleButtonClick = this._onToggleButtonClick.bind(this);
    }
    /**
     * Handler for the toggle button.
     *
     * @param {Object} e - The synthetic event.
     * @returns {void}
     */
    _onToggleButtonClick() {
        var showNews = localStorage.getItem("showAgainGreetings2");
        if (showNews != null && showNews == 'false') {
            localStorage.setItem("showAgainGreetings2", 'true');
        }
        else {
            localStorage.setItem("showAgainGreetings2", 'false');
        }
    }
    downloadInfoGraphic() {
        // Fire event with GTM
        window.dataLayer = window.dataLayer || [];
        // Fire event with GTM
        window.dataLayer.push({
            'event': 'virtualEvent',
            'eventCategory': 'Download',
            'eventAction': 'White Paper - Data Center',
            'eventLabel': window.location.href
        });
        window.open('https://www.vianova.it/files/white-papers/Vianova_White_paper-Data_Center.pdf', '_blank');
        this.setState({ hide: false });
    }
    render() {
        var name = "";
        let us = localStorage.getItem("user");
        if (us != null) {
            var user = JSON.parse(us?.toString());
            if (user.result == 1) {
                name = user.name;
            }
        }
        let intestazione = this.props.t('GreetingsPopup2.intestazione', { name });
        if (name !== "") {
            //LOGGATO
            return (React.createElement("div", { className: "modal" },
                React.createElement("div", { className: "modal-greetings" },
                    React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                    React.createElement("h1", { className: "testoPopup" }, intestazione),
                    React.createElement("div", { className: "divP" },
                        React.createElement("img", { className: "immagineLog2", src: "images/POPUP_Smart_Whitepaper_DataCenter.jpg?versionid=225", alt: "#" }),
                        React.createElement("div", { className: "divPP" },
                            React.createElement("h2", { className: "testoPopup2" },
                                this.props.t('GreetingsPopup2.testo1'),
                                React.createElement("br", null),
                                " ",
                                this.props.t('GreetingsPopup2.testo2')),
                            React.createElement("h5", { className: "testoPopup3" }, this.props.t('GreetingsPopup2.testo3')),
                            React.createElement("button", { className: "buttonGreeting1", name: "buttonInfografica", onClick: this.downloadInfoGraphic.bind(this) },
                                " ",
                                this.props.t('GreetingsPopup2.download'),
                                " "),
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'left' } },
                                React.createElement("input", { style: { width: '20px', height: '20px', marginRight: '8px' }, type: "checkbox", defaultChecked: this.state.chkbox, onChange: this._onToggleButtonClick }),
                                React.createElement("small", { className: "testoPopupnewFeatures" },
                                    " ",
                                    this.props.t('GreetingsPopup2.doNotShow'),
                                    " "))),
                        React.createElement("br", null)))));
        }
        else {
            // NON LOGGATO
            return (React.createElement("div", { className: "modal" },
                React.createElement("div", { className: "modal-greetings" },
                    React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                    React.createElement("h1", { className: "testoPopup" }, intestazione),
                    React.createElement("div", { className: "divGreetings" },
                        React.createElement("div", { className: "divGreetings2" },
                            React.createElement("img", { className: "immagineNoLog", src: "images/POPUP_Smart_Whitepaper_DataCenter.jpg?versionid=225", alt: "#" }),
                            React.createElement("div", { style: { display: 'flex', width: '78%', flexDirection: 'column' } },
                                React.createElement("div", { style: { marginTop: '20px', marginBottom: '20px' } },
                                    React.createElement("h2", { className: "testoPopup2" },
                                        this.props.t('GreetingsPopup2.testo1'),
                                        this.props.t('GreetingsPopup2.testo2'),
                                        React.createElement("br", null)),
                                    React.createElement("h4", { className: "testoPopup2" }, this.props.t('GreetingsPopup2.testo3'))),
                                this.state.hide ? React.createElement("h4", { className: "testoPopup2" }, this.props.t('GreetingsPopup2.testo6')) : null,
                                this.state.hide ? React.createElement("div", { style: { display: 'flex', marginBottom: '10px', marginTop: '10px' } },
                                    React.createElement("img", { className: "leitmotivVI", src: "images/leitmotiv.svg?versionid=225", alt: "#" }),
                                    React.createElement("small", { className: "testoPopup2" }, this.props.t('GreetingsPopup2.testo5'))) : null,
                                React.createElement(HubspotForm, { region: "na1", portalId: "8221575", formId: "c9178927-c99a-48a1-8a2f-1f26856a7922", cssClass: "hub-cform", onFormSubmitted: this.downloadInfoGraphic.bind(this) }))),
                        React.createElement("br", null)))));
        }
    }
}
export default translate(connect(_mapStateToProps)(GreetingsPopup));
